/**
 * Vehicle insurance claim record category values
 */
export enum VehicleInsuranceClaimRecordCategoryEnum {
	VEHICLE = 'vehicle',
	RENTAL_AGREEMENT = 'rental_agreement',
}
